<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/account"></ion-back-button>
    </ion-buttons>
    <ion-title>My Profile</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content color="lightmimbo">
  <form #f="ngForm" class="ion-padding">
    <ion-grid>
      <ion-row>
        <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
          <ion-list>
            <ion-item color="lightmimbo">
              <ion-input
                name="email"
                label="Email"
                labelPlacement="floating"
                required
                readonly
                [value]="email"
              ></ion-input>
            </ion-item>
            <ion-item color="lightmimbo">
              <ion-input
                type="text"
                name="username"
                [(ngModel)]="username"
                (ionInput)="resetUsername()"
                (ionBlur)="checkUsername($event)"
                label="Username"
                labelPlacement="floating"
                required
              ></ion-input>
            </ion-item>
            <ion-item lines="none" color="lightmimbo" *ngIf="usernameExists">
              <ion-text color="danger"
                ><small>Username already taken.</small></ion-text
              >
            </ion-item>
            <ion-item color="lightmimbo">
              <ion-input
                type="text"
                name="firstName"
                label="First Name"
                labelPlacement="floating"
                [(ngModel)]="firstName"
                required
              ></ion-input>
            </ion-item>
            <ion-item color="lightmimbo">
              <ion-input
                type="text"
                name="lastName"
                label="Last Name"
                labelPlacement="floating"
                [(ngModel)]="lastName"
                required
              ></ion-input>
            </ion-item>
          </ion-list>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="ion-text-center">
          <ion-button
            color="primary"
            (click)="updateProfile()"
            [disabled]="!f.valid"
            ><ion-icon name="save-outline" slot="start"></ion-icon>Update
            Profile</ion-button
          >
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</ion-content>
